import { useState, useEffect, useCallback } from 'react';
import { empleadoService } from '../services/supabase';

export function useEmpleados(usuarioId, campoId) {
  const [empleados, setEmpleados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadEmpleados = useCallback(async () => {
    if (!usuarioId || !campoId) return;
    setLoading(true);
    setError(null);
    try {
      const data = await empleadoService.getAll(usuarioId, campoId);
      setEmpleados(data || []);
    } catch (e) {
      setError(e.message);
      console.error('Error cargando empleados:', e);
    } finally {
      setLoading(false);
    }
  }, [usuarioId, campoId]);

  useEffect(() => {
    loadEmpleados();
  }, [loadEmpleados]);

  const createEmpleado = useCallback(async (empleado) => {
    if (!usuarioId || !campoId) throw new Error("usuarioId y campoId requeridos");
    try {
      const saved = await empleadoService.create(usuarioId, campoId, empleado);
      setEmpleados(prev => [...prev, saved]);
      return saved;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, [usuarioId, campoId]);

  const updateEmpleado = useCallback(async (empleadoId, updates) => {
    try {
      const updated = await empleadoService.update(empleadoId, updates);
      setEmpleados(prev => prev.map(e => e.id === empleadoId ? updated : e));
      return updated;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, []);

  const deleteEmpleado = useCallback(async (empleadoId) => {
    try {
      await empleadoService.delete(empleadoId);
      setEmpleados(prev => prev.filter(e => e.id !== empleadoId));
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, []);

  return {
    empleados,
    setEmpleados,
    loading,
    error,
    loadEmpleados,
    createEmpleado,
    updateEmpleado,
    deleteEmpleado,
  };
}
